import * as React from 'react';
import classNames from 'classnames';
import { AddOnCategoryId, AddOnCategory } from './types';
import {l} from '../localize';

type AddOnsFilterProps = {
	categories: AddOnCategory[];
	filterBy: AddOnCategoryId | false;
	onChangeFilter: (id: AddOnCategoryId | false) => void;
};

const AddOnsFilter: React.FC<AddOnsFilterProps> = ({
	categories,
	filterBy,
	onChangeFilter,
}) => {
	if (!categories || categories.length === 0) return <></>;

	const allClassName = classNames(
		['add-on-filter__category', 'add-on-filter__category--dark-green'],
		{ 'add-on-filter__category--active': filterBy === false },
	);

	return (
		<nav className="sort-bar add-on-filter">
			<button className={allClassName} onClick={() => onChangeFilter(false)}>
				{l('all')}
			</button>
			{categories.map(category => {
				const className = classNames(
					[
						'add-on-filter__category',
						`add-on-filter__category--${category.color}`,
					],
					{ 'add-on-filter__category--active': category.id === filterBy },
				);

				return (
					<button
						key={category.id}
						className={className}
						onClick={() => onChangeFilter(category.id)}
					>
						{category.name}
					</button>
				);
			})}
		</nav>
	);
};

export default AddOnsFilter;
